const colorSelectionElem = document.querySelector('.color-selection');

if (colorSelectionElem) {
  attachEvent('.color-selection__list-link', 'click', (btn) => {
    const imageElement = btn.target.querySelector('img');
    const textElement = btn.target.querySelector('.link-text');

    if (!imageElement || !textElement) return;

    const imageSrc = imageElement.getAttribute('src');
    const text = textElement.textContent;

    const parent = btn.target.closest('.color-selection');
    const selectedImage = parent.querySelector('.color-selection__selected-color img');
    const selectedText = parent.querySelector('.color-selection__selected-text');

    if (selectedImage && selectedText) {
      selectedImage.setAttribute('src', imageSrc);
      selectedImage.setAttribute('alt', text);
      selectedText.textContent = text;
    }
    const otherActiveClass = parent.querySelector('.is-active');
    otherActiveClass.classList.remove('is-active');
    btn.target.classList.add('is-active');
  });
}
